import type { IconName } from "@/ui/icons/Icon";
import type { OfferFaqItem } from "../../components/OfferFaq";
import type { LandingReview } from "../../components/LandingReviews";
import type { LandingStep } from "../../components/LandingSteps";

export interface RefinanceUsp {
  // Line breaks as in the design.
  label: string;
  icon: IconName;
  // The coins glyph fills its whole box; the other icons have a 4px margin.
  iconSize?: number;
}

// The last one spans the whole row.
export const USPS: RefinanceUsp[] = [
  { label: "Rată unică\nmai mică", icon: "money-bills" },
  { label: "Bani de cheltuială", icon: "coins", iconSize: 24 },
  { label: "Suport\ndedicat", icon: "phone" },
  { label: "Fără comisioane ascunse", icon: "shield-check-fill" },
  { label: "Un singur credit\ngestionat în Volt", icon: "mobile" },
];

// Store reviews about refinancing. No avatars: the design's photos are stock,
// and a stranger's face on someone's debt story would misrepresent them.
export const REVIEWS: LandingReview[] = [
  {
    name: "Marius-Nicolae Pusta",
    date: "2026-01-26",
    quote:
      "Gradul de îndatorare mă bloca peste tot unde încercam. Aici am reușit: de la 3500 lei pe lună am ajuns la 2200. Foarte bine.",
  },
  {
    name: "Sorela-Raluca-Simona Scondac",
    date: "2025-07-18",
    quote:
      "Peste tot mă loveam de gradul mare de îndatorare. Aici am dat de oameni care chiar caută soluții la problemele întâmpinate, nu îți spun doar „nu se poate”. Am trecut de la 1500 lei pe lună la 400.",
  },
  {
    name: "Lucian Oltean Pauletti",
    date: "2026-08-26",
    quote:
      "Plăteam 2073 lei pe lună la toate creditele. Acum am o singură rată de 456 lei. Ce m-a surprins a fost că ați dat dovadă de înțelegere și profesionalism, nu m-am simțit ca un simplu dosar.",
  },
  {
    name: "Popescu Bogdan Ionut",
    date: "2026-08-26",
    quote:
      "Am încercat prima dată la banca unde am cardul și am fost respins, fără să-mi explice nimeni de ce. La Ocean Credit a mers super, rapid și simplu. Plăteam peste 400 de lei pe lună, acum plătesc 262,90.",
  },
];

export const STEPS: LandingStep[] = [
  { title: "Trimiți cererea", subtitle: "Durează 1 min" },
  { title: "Analizăm situația ta", subtitle: "Durează maxim 3 zile" },
  {
    title: "Te contactăm noi",
    subtitle: "Vei fi sunat de un specialist care te ghidează pas cu pas.",
  },
];

// Only the first answer is in the design; the others are the mobile app's.
export const FAQ: OfferFaqItem[] = [
  {
    question: "Cum funcționează refinanțarea externă?",
    answer: [
      "Îți închidem creditele de la alte instituții și le înlocuim cu unul singur. Rămâi cu o singură rată lunară, de obicei mai mică decât toate cele de acum — și, dacă te califici, poți primi și bani în plus. Totul se gestionează din contul tău Volt.",
    ],
  },
  {
    question: "Ce documente sunt necesare pentru refinanțare?",
    answer: [
      "Ai nevoie doar de un act de identitate valid. Datele despre creditele tale actuale și despre venituri le preluăm automat din Biroul de Credit și ANAF, cu acordul tău.",
    ],
  },
  {
    question: "Cum primesc o ofertă de refinanțare?",
    answer: [
      "Trimiți cererea din aplicație, iar noi analizăm situația ta în maximum 3 zile. Dacă te califici, te contactăm cu oferta și îți explicăm pas cu pas ce urmează.",
    ],
  },
  {
    question: "Ce se întâmplă dacă rămân bani în plus după refinanțare?",
    answer: [
      "Banii rămași după închiderea creditelor tale actuale îi primești în cont și îi poți folosi cum vrei — nu sunt legați de o destinație anume.",
    ],
  },
];
